module.exports = __webpack_public_path__ + "media/components/web/pages/index/resources/svgs/pattern_right_mobile-70d4d261d96337e2706144139f137545.svg";